










































import { DEALER_SITE_NS } from '~/store/modules/shared/dealers/site/state'
import { mapGetters, mapState } from 'vuex'
import DirectionsButton from '../../../maps/DirectionsButton.vue'
import { defineComponent } from '~/utils/nuxt3-migration'
import { ciEnvelope } from '~/icons/source/solid/envelope'
import { ciTelephone } from '~/icons/source/solid/telephone'
import { ciLocationPin } from '~/icons/source/solid/location-pin'

export default defineComponent({
  components: {
    DirectionsButton
  },
  setup() {
    return {
      ciTelephone,
      ciLocationPin,
      ciEnvelope
    }
  },
  computed: {
    ...mapState(DEALER_SITE_NS, ['outlets']),
    ...mapGetters(DEALER_SITE_NS, {
      outlet: 'firstOutlet',
      getTemplateOption: 'getTemplateOption'
    }),
    textColor(): string {
      return this.getTemplateOption('footer_text_color')
    }
  }
})
